import { render, staticRenderFns } from "./useModal.vue?vue&type=template&id=def71b88&scoped=true&"
import script from "./useModal.vue?vue&type=script&lang=js&"
export * from "./useModal.vue?vue&type=script&lang=js&"
import style0 from "./useModal.vue?vue&type=style&index=0&id=def71b88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def71b88",
  null
  
)

export default component.exports